/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const RotateMonitoringCredentialHeaders = zod.object({
  'x-csrf-token': zod.string(),
  'Idempotency-Key': zod.string(),
});

export type RotateMonitoringCredentialHeaders = zod.input<typeof RotateMonitoringCredentialHeaders>;
export type RotateMonitoringCredentialHeadersOutput = zod.output<
  typeof RotateMonitoringCredentialHeaders
>;
